import * as React from 'react';

import {InfoIcon} from 'shells/icon/svg/info-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {Body} from 'shells/typography/body';

import styles from './security-page.module.css';

type Props = {
    emailAcls: string;
    setEmailAcls: (emailAcls: string) => void;
    userSessionLength: number;
    setUserSessionLength: (userSessionLength: number) => void;
    isLoading: boolean;
};

const DEFAULT_SESSION_LENGTH = 0; // disabled

const SESSION_LENGTH_OPTIONS = [
    {value: 60, label: '1 Hour'},
    {value: 120, label: '2 Hours'},
    {value: 240, label: '4 Hours'},
    {value: 480, label: '8 Hours'},
    {value: 720, label: '12 Hours'},
    {value: 1440, label: '24 Hours'},
    {value: DEFAULT_SESSION_LENGTH, label: 'Never'},
];

export function SecuritySettingsSection(props: Props) {
    if (props.isLoading) {
        return <LoadingPage />;
    }

    return (
        <div className='pad-16'>
            <StackLegacy spacing={16} isHorizontal={true}>
                <StackLegacy spacing={8}>
                    <div className={styles['view-restricted-radio']}>
                        <InfoIcon size={24} alignCenter={true} className={styles['info-icon']} />
                        <Body size='small' isBold={true}>
                            What can view-restricted users see?
                        </Body>
                    </div>
                    <StackLegacy spacing={4} isHorizontal={true} alignCenter={true}>
                        <InfoIcon size={24} alignCenter={true} className={styles['info-icon']} />
                        <Body size='small' isBold={true}>
                            Session timeout
                        </Body>
                    </StackLegacy>
                </StackLegacy>
                <StackLegacy spacing={8}>
                    <RadioGroup
                        name='view-restricted-users'
                        selectedValue={props.emailAcls}
                        onChange={(value) => {
                            props.setEmailAcls(value);
                        }}
                        spacing={2}
                    >
                        <Radio value='0' size={13}>
                            Emails attached to anything they can see
                        </Radio>
                        <Radio value='1' size={13}>
                            Only emails they sent or received
                        </Radio>
                    </RadioGroup>
                    <div className={styles['session-timeout-select']}>
                        <SelectPickerGeneric
                            // @ts-expect-error
                            onChange={(value) => {
                                props.setUserSessionLength(value.value);
                            }}
                            options={SESSION_LENGTH_OPTIONS}
                            isSearchable={false}
                            value={
                                SESSION_LENGTH_OPTIONS.find(
                                    (option) => option.value === props.userSessionLength
                                ) || SESSION_LENGTH_OPTIONS[6]
                            }
                        />
                    </div>
                </StackLegacy>
            </StackLegacy>
        </div>
    );
}
